import { Form, Formik } from "formik";
import * as Yup from "yup";
import Input from "../../../component-lib/Atoms/Input/Input";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import Button from "../../../component-lib/Molecules/button/Button";
import SelectDropdown from "../../../component-lib/Atoms/Select/Select";
import EventEHRTimePicker from "../../Molecules/time-picker/EventEHRTimePicker";
import FacilitySelect from "./FacilitySelect";
import IncidentLocationSelect from "./IncidentLocationSelect";
import { CREATE_VISIT_FORM_DETAILS } from "./constants";
import DatePicker from "../../Atoms/DatePicker/DatePicker";
import { Dayjs } from "dayjs";
import moment from "moment";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import { useState } from "react";
import { VALIDATION_CONSTANTS } from "../../../utils/validation-constants/validationConstants";
interface CreateVisitFormProps {
  defaultSelectedData?: any;
  comesFrom?: string;
  handleOnSubmittedData?: (formData: any) => void;
}

const CreateVisitForm = ({
  comesFrom,
  defaultSelectedData,
  handleOnSubmittedData,
}: CreateVisitFormProps) => {
  // The facility list is now lazy-loaded inside FacilitySelect; we only keep
  // the currently selected option here so it persists across open/close and so
  // its `department` array can drive the Type of Care list.
  const [selectedFacility, setSelectedFacility] = useState<any>(null);
  const [typeOfCareList, setTypeOfCareList] = useState<any>([]);
  const isComesFromDashboard = comesFrom === "dashboard" ? true : false;

  const validationSchema = Yup.object().shape({
    // [CREATE_VISIT_FORM_DETAILS.PATIENT_NAME]: Yup.string()
    //   .matches(
    //     VALIDATION_CONSTANTS.NAME,
    //     "Patient name can only contain alphanumeric characters"
    //   )
    //   .required("Patient name is required"),
    // [CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID]: Yup.string()
    //   .matches(
    //     VALIDATION_CONSTANTS.ID,
    //     "BSA ID can only contain letters and numbers"
    //   )
    //   .required("BSA ID is required"),
    // [CREATE_VISIT_FORM_DETAILS.CAMP_NAME]: Yup.string()
    //   .matches(
    //     VALIDATION_CONSTANTS.NAME,
    //     "Camp name can only contain alphanumeric characters"
    //   )
    //   .required("Camp name is required"),
    // [CREATE_VISIT_FORM_DETAILS.JUN]: Yup.string()
    //   .matches(
    //     VALIDATION_CONSTANTS.ID,
    //     "Jamboree unit number must contain only letters and numbers"
    //   )
    //   .required("Jamboree unit number is required"),
    [CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT]: Yup.string().required(
      "Chief Complaint is required"
    ),
    [CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE]: Yup.string().test(
      "max-date",
      "Incident date cannot be in the future",
      (value) => {
        // Ensure the date is not in the future
        return value ? new Date(value) <= new Date() : true;
      }
    ),

    [CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME]: Yup.string().test(
      "is-not-future-time",
      "Incident time cannot be in the future",
      function (value) {
        const { incidentDate } = this.parent; // Access the incident date field
        if (!incidentDate || !value) return true; // Skip validation if missing

        // Parse date and time correctly
        const datePart = moment(incidentDate).format("YYYY-MM-DD"); // Standardize date
        const timePart = moment(value).format("HH:mm:ss"); // Standardize time

        // Combine date and time into a single Date object
        const combinedDateTime = moment(`${datePart}T${timePart}`).toDate();

        // Current time
        const now = new Date();

        // Validation: Combined date-time should not be in the future
        return combinedDateTime <= now;
      }
    ),
    [CREATE_VISIT_FORM_DETAILS.WITNESS_NAME]: Yup.string().matches(
      VALIDATION_CONSTANTS.CHARACTER,
      "Witness name can only contain characters"
    ),
    [CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL]: Yup.string().matches(
      VALIDATION_CONSTANTS.EMAIL,
      "Enter a valid email address"
    ),
    [CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE]: Yup.string().required(
      "Type of care is required"
    ),
    [CREATE_VISIT_FORM_DETAILS.FACILITY]: Yup.string().required(
      "Facility is required"
    ),
  });

  const headerStyle = {
    fontWeight: "500",
    fontSize: "16px",
    paddingBottom: "10px",
  };

  const commonGridStyle = {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "14px",
  };

  return (
    <>
      <Formik
        initialValues={{
          [CREATE_VISIT_FORM_DETAILS.PATIENT_NAME]: isComesFromDashboard
            ? ""
            : `${defaultSelectedData?.firstName ? defaultSelectedData?.firstName : "-"} ${defaultSelectedData?.lastName ? defaultSelectedData?.lastName : ""}`,
          [CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID]: isComesFromDashboard
            ? ""
            : `${defaultSelectedData?.bsaId ? defaultSelectedData?.bsaId : "-"}`,
          [CREATE_VISIT_FORM_DETAILS.CAMP_NAME]: isComesFromDashboard
            ? ""
            : `${defaultSelectedData?.campName ? defaultSelectedData?.campName : "-"}`,
          [CREATE_VISIT_FORM_DETAILS.JUN]: isComesFromDashboard
            ? ""
            : `${defaultSelectedData?.unitNumber ? defaultSelectedData?.unitNumber : "-"}`,
          [CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT]: "",
          [CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE]: undefined,
          [CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME]: "",
          [CREATE_VISIT_FORM_DETAILS.INCIDENT_LOCATION]: "",
          [CREATE_VISIT_FORM_DETAILS.WITNESS_NAME]: "",
          [CREATE_VISIT_FORM_DETAILS.WITNESS_CONTACT_NAME]: "",
          [CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL]: "",
          [CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE]: "",
          [CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE_NAME]: "",
          [CREATE_VISIT_FORM_DETAILS.FACILITY]: "",
        }}
        validationSchema={validationSchema}
        //   validateOnChange={false}
        //   validateOnBlur={false}
        enableReinitialize
        onSubmit={(values, { setSubmitting }) => {
          try {
            handleOnSubmittedData && handleOnSubmittedData(values);
            // Handle form data here
            // If needed, call an API or further process the values here
          } catch (error) {
            console.log(error);
          } finally {
            setSubmitting(false); // Reset submitting state
          }
        }}
      >
        {({
          errors,
          submitForm,
          isSubmitting,
          handleReset,
          isValid,
          values,
          touched,
          setFieldValue,
          handleBlur,
          handleSubmit,
        }) => {
          return (
            <Form
              onSubmit={handleSubmit}
              className="h-full flex flex-col justify-between"
            >
              <div className="w-full flex flex-col gap-6">
                {/* PATIENT DETAILS */}
                <div>
                  <Heading title="Patient Details" customStyle={headerStyle} />
                  <div style={commonGridStyle}>
                    <Input
                      disabled={!isComesFromDashboard}
                      textFieldLabel="BSA ID"
                      name={CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID}
                      value={values[CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID,
                          e.target.value
                        );
                      }}
                      size="small"
                      onBlur={handleBlur}
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID] &&
                        Boolean(
                          errors[CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID]
                        )
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID]
                          ? errors[CREATE_VISIT_FORM_DETAILS.PATIENT_BSA_ID]
                          : undefined
                      }
                    />

                    <Input
                      disabled={!isComesFromDashboard}
                      textFieldLabel="Patient Name"
                      name={CREATE_VISIT_FORM_DETAILS.PATIENT_NAME}
                      value={values[CREATE_VISIT_FORM_DETAILS.PATIENT_NAME]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.PATIENT_NAME,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      size="small"
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.PATIENT_NAME] &&
                        Boolean(errors[CREATE_VISIT_FORM_DETAILS.PATIENT_NAME])
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.PATIENT_NAME]
                          ? errors[CREATE_VISIT_FORM_DETAILS.PATIENT_NAME]
                          : undefined
                      }
                    />

                    <Input
                      disabled={!isComesFromDashboard}
                      textFieldLabel="Jamboree Unit Number"
                      name={CREATE_VISIT_FORM_DETAILS.JUN}
                      value={values[CREATE_VISIT_FORM_DETAILS.JUN]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.JUN,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      size="small"
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.JUN] &&
                        Boolean(errors[CREATE_VISIT_FORM_DETAILS.JUN])
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.JUN]
                          ? errors[CREATE_VISIT_FORM_DETAILS.JUN]
                          : undefined
                      }
                    />
                  </div>
                </div>

                {/* CHIEF COMPLAINT SECTION */}
                <div>
                  <Heading
                    title="Chief Complaint"
                    isRequired={true}
                    customStyle={headerStyle}
                  />
                  <div>
                    <Input
                      multiline={true}
                      rows={3}
                      textFieldLabel="Enter Chief Complaint"
                      maxWords={250}
                      name={CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT}
                      value={values[CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT,
                          e.target.value
                        );
                      }}
                      onBlur={handleBlur}
                      size="small"
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT] &&
                        Boolean(
                          errors[CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT]
                        )
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT]
                          ? errors[CREATE_VISIT_FORM_DETAILS.CHIEF_COMPLAINT]
                          : undefined
                      }
                    />
                  </div>
                </div>

                {/* INCIDENT DETAILS */}
                <div>
                  <Heading title="Incident Details" customStyle={headerStyle} />
                  <div
                    style={{
                      ...commonGridStyle,
                      rowGap: "21px",
                      columnGap: "16px",
                    }}
                  >
                    <DatePicker
                      name={CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE}
                      value={values[CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE]}
                      onChangeCb={(value) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE,
                          value
                        );
                      }}
                      // isStarPresent={true}
                      label="Enter Incident Date"
                      style={{ width: "100%" }}
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE] &&
                        Boolean(errors[CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE])
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE]
                          ? errors[CREATE_VISIT_FORM_DETAILS.INCIDENT_DATE]
                          : undefined
                      }
                      maxDate={moment()}
                    />
                    <EventEHRTimePicker
                      name={CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME}
                      value={values[CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME]}
                      onChangeCb={(value) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME,
                          value
                        );
                      }}
                      // isStarPresent={true}
                      label="Enter Incident Time"
                      style={{ width: "100%" }}
                      onBlur={handleBlur}
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME] &&
                        Boolean(errors[CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME])
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME]
                          ? errors[CREATE_VISIT_FORM_DETAILS.INCIDENT_TIME]
                          : undefined
                      }
                      // ampmFormat={true} // For 12hr time format
                    />

                    <Input
                      textFieldLabel="Witness Name"
                      // isStarPresent={true}
                      maxLength={100}
                      name={CREATE_VISIT_FORM_DETAILS.WITNESS_NAME}
                      value={values[CREATE_VISIT_FORM_DETAILS.WITNESS_NAME]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.WITNESS_NAME,
                          e.target.value
                        );
                      }}
                      size="small"
                      onBlur={handleBlur}
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.WITNESS_NAME] &&
                        Boolean(errors[CREATE_VISIT_FORM_DETAILS.WITNESS_NAME])
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.WITNESS_NAME]
                          ? errors[CREATE_VISIT_FORM_DETAILS.WITNESS_NAME]
                          : undefined
                      }
                    />

                    <Input
                      textFieldLabel="Witness Email"
                      maxLength={100}
                      name={CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL}
                      value={values[CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL]}
                      onChangeCb={(e) => {
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL,
                          e.target.value
                        );
                      }}
                      size="small"
                      onBlur={handleBlur}
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL] &&
                        Boolean(errors[CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL])
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL]
                          ? errors[CREATE_VISIT_FORM_DETAILS.WITNESS_EMAIL]
                          : undefined
                      }
                    />

                    <IncidentLocationSelect
                      value={
                        values[CREATE_VISIT_FORM_DETAILS.INCIDENT_LOCATION] ?? ""
                      }
                      onChange={(val) =>
                        setFieldValue(
                          CREATE_VISIT_FORM_DETAILS.INCIDENT_LOCATION,
                          val
                        )
                      }
                      onBlur={handleBlur}
                      error={
                        touched[CREATE_VISIT_FORM_DETAILS.INCIDENT_LOCATION] &&
                        Boolean(
                          errors[CREATE_VISIT_FORM_DETAILS.INCIDENT_LOCATION]
                        )
                      }
                      helperText={
                        touched[CREATE_VISIT_FORM_DETAILS.INCIDENT_LOCATION]
                          ? errors[CREATE_VISIT_FORM_DETAILS.INCIDENT_LOCATION]
                          : undefined
                      }
                    />
                  </div>
                </div>

                {/* TYPE OF CARE SECTION */}
                <div>
                  <Heading
                    isRequired={true}
                    title="Type of Care"
                    customStyle={headerStyle}
                  />
                  <div className="flex gap-4">
                    <div className="w-full">
                      <FacilitySelect
                        selectedValue={selectedFacility}
                        error={
                          touched[CREATE_VISIT_FORM_DETAILS.FACILITY] &&
                          Boolean(errors[CREATE_VISIT_FORM_DETAILS.FACILITY])
                        }
                        helperText={
                          touched[CREATE_VISIT_FORM_DETAILS.FACILITY]
                            ? errors[CREATE_VISIT_FORM_DETAILS.FACILITY]
                            : undefined
                        }
                        onSelect={(facility: any) => {
                          setSelectedFacility(facility);
                          setFieldValue(
                            CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE,
                            ""
                          );
                          setFieldValue(
                            CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE_NAME,
                            ""
                          );

                          const department = facility?.department?.length
                            ? facility?.department?.map((data: any) => ({
                                label: data?.name,
                                value: data?.id,
                              }))
                            : [];
                          // Self Care / Nurse Care are no longer defaults; the
                          // list is driven purely by the facility's configured
                          // departments.
                          setTypeOfCareList([...department]);
                          setFieldValue(
                            CREATE_VISIT_FORM_DETAILS.FACILITY,
                            facility?.value || ""
                          );
                        }}
                      />
                    </div>
                    <div className="w-full">
                      <SelectDropdown
                        label="Select Type of Care"
                        value={values[CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE]}
                        options={typeOfCareList}
                        onChangeCb={(e, label) => {
                          setFieldValue(
                            CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE,
                            e.target.value
                          );
                          setFieldValue(
                            CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE_NAME,
                            label !== "Self Care" ? label : "Self_Care"
                          );
                        }}
                        error={
                          touched[CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE] &&
                          Boolean(errors[CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE])
                        }
                        helperText={
                          touched[CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE]
                            ? errors[CREATE_VISIT_FORM_DETAILS.TYPE_OF_CARE]
                            : undefined
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-end mt-10">
                {/* REMOVE this when api integration */}
                {/* <div
                  className="cursor-pointer"
                  onClick={() => {
                    setOpenTriage(true);
                  }}
                >
                  OPEN TRIAGE
                </div> */}
                <Button
                  // disabled={!isValid} // Button disabled if form is invalid or submitting
                  type="submit"
                  label={TEXT_CONSTANTS?.CREATE_VISIT}
                  variant="contained"
                  onClickCb={() => {}}
                  style={{
                    padding: "8px 55px",
                    fontSize: "16px",
                  }}
                ></Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateVisitForm;
